import React, { useEffect, useState } from 'react';

interface DirectoryItem {
  subdomain: string;
  site_name: string;
}

const GlobalFooter = () => {
  const [links, setLinks] = useState<DirectoryItem[]>([]);

  useEffect(() => {
    // Call the directory API
    fetch('https://lightapp-api.promptvault.work/api/directory')
      .then(res => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then(data => {
        // Safety check: ensure data is an array
        if (Array.isArray(data)) {
          setLinks(data);
        } else {
          console.error("API returned incorrect format:", data);
        }
      })
      .catch(err => console.error("Failed to load footer links:", err));
  }, []);

  // If no links, return null to hide the section
  if (links.length === 0) return null; 

  return (
    <footer className="bg-slate-900 text-slate-400 py-12 px-6 border-t border-slate-800">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-white font-bold mb-6 text-lg">More Useful Tools from PromptVault</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {links.map((item) => (
            <a 
              key={item.subdomain}
              href={`https://${item.subdomain}`}
              className="hover:text-cyan-400 transition-colors duration-200 text-sm flex items-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.site_name} 
              <span className="ml-1 text-xs">→</span>
            </a>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-slate-800 text-center text-xs text-slate-500">
          © 2025 PromptVault Network. Helping you calculate with professional precision.
        </div>
      </div>
    </footer>
  );
};

export default GlobalFooter;